"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppSettingsCurrency = useAppSettingsCurrency;
exports.useAppSettingsLocale = useAppSettingsLocale;
exports.useAppSettingsRouteUrl = useAppSettingsRouteUrl;
exports.useAppSettingsSiteRoot = useAppSettingsSiteRoot;
exports.default = void 0;

var _invariant = _interopRequireDefault(require("invariant"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AppSettingsContext = _interopRequireDefault(require("./AppSettingsContext"));

/**
 * @component
 */
function AppSettinngsProvider(_ref) {
  var AgreementFieldCustomerVerifiedComponent = _ref.AgreementFieldCustomerVerifiedComponent,
      AgreementFieldGdprComponent = _ref.AgreementFieldGdprComponent,
      AgreementFieldProductGdprComponent = _ref.AgreementFieldProductGdprComponent,
      AgreementFieldTermsComponent = _ref.AgreementFieldTermsComponent,
      billingIncludeCountries = _ref.billingIncludeCountries,
      children = _ref.children,
      currency = _ref.defaultCurrency,
      locale = _ref.defaultLocale,
      phoneNumbersIncludeCountries = _ref.phoneNumbersIncludeCountries,
      ProductDetailCertificateComponent = _ref.ProductDetailCertificateComponent,
      ProductDetailShippingDateComponent = _ref.ProductDetailShippingDateComponent,
      routeUrl = _ref.routeUrl,
      shippingIncludeCountries = _ref.shippingIncludeCountries,
      siteRoot = _ref.siteRoot;
  return /*#__PURE__*/_react.default.createElement(_AppSettingsContext.default.Provider, {
    value: {
      AgreementFieldCustomerVerifiedComponent: AgreementFieldCustomerVerifiedComponent,
      AgreementFieldGdprComponent: AgreementFieldGdprComponent,
      AgreementFieldProductGdprComponent: AgreementFieldProductGdprComponent,
      AgreementFieldTermsComponent: AgreementFieldTermsComponent,
      billingIncludeCountries: billingIncludeCountries,
      currency: currency,
      locale: locale,
      routeUrl: routeUrl,
      phoneNumbersIncludeCountries: phoneNumbersIncludeCountries,
      ProductDetailCertificateComponent: ProductDetailCertificateComponent,
      ProductDetailShippingDateComponent: ProductDetailShippingDateComponent,
      shippingIncludeCountries: shippingIncludeCountries,
      siteRoot: siteRoot
    }
  }, children);
}

process.env.NODE_ENV !== "production" ? AppSettinngsProvider.propTypes = {
  AgreementFieldCustomerVerifiedComponent: _propTypes.default.elementType.isRequired,
  AgreementFieldGdprComponent: _propTypes.default.elementType.isRequired,
  AgreementFieldProductGdprComponent: _propTypes.default.elementType.isRequired,
  AgreementFieldTermsComponent: _propTypes.default.elementType.isRequired,
  billingIncludeCountries: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string)).isRequired,
  children: _propTypes.default.node,
  defaultCurrency: _propTypes.default.string.isRequired,
  defaultLocale: _propTypes.default.string.isRequired,
  phoneNumbersIncludeCountries: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))).isRequired,
  ProductDetailCertificateComponent: _propTypes.default.elementType,
  ProductDetailShippingDateComponent: _propTypes.default.elementType.isRequired,
  routeUrl: _propTypes.default.func,
  shippingIncludeCountries: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string)).isRequired,
  siteRoot: _propTypes.default.string
} : void 0;
AppSettinngsProvider.defaultProps = {
  children: null,
  ProductDetailCertificateComponent: null
};
var _default = AppSettinngsProvider;
exports.default = _default;

function useAppSettingsCurrency() {
  var ctx = _react.default.useContext(_AppSettingsContext.default);

  (0, _invariant.default)(ctx, "Don't use 'useAppSettingsCurrency' outside of <AppSettinngsProvider>");
  return ctx.currency;
}

function useAppSettingsLocale() {
  var ctx = _react.default.useContext(_AppSettingsContext.default);

  (0, _invariant.default)(ctx, "Don't use 'useAppSettingsLocale' outside of <AppSettinngsProvider>");
  return ctx.locale;
}

function useAppSettingsRouteUrl() {
  var ctx = _react.default.useContext(_AppSettingsContext.default);

  (0, _invariant.default)(ctx, "Don't use 'useAppSettingsRouteUrl' outside of <AppSettinngsProvider>");
  return ctx.routeUrl;
}

function useAppSettingsSiteRoot() {
  var ctx = _react.default.useContext(_AppSettingsContext.default);

  (0, _invariant.default)(ctx, "Don't use 'useAppSettingsSiteRoot' outside of <AppSettinngsProvider>");
  return ctx.siteRoot;
}